import styled from 'styled-components';

export const Button = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    flex-shrink: 0;

    svg {
        color: ${(props) => props.theme.palette.textLight};
    }
    &:hover {
        svg {
            color: ${(props) => props.theme.palette.primaryA1};
        }
    }
`;

export const COPY_ICON_CLASS = 'copy-icon';

/**
 * Spread onto the parent element that wraps a `<ButtonCopyText revealOnHover />`.
 * Keeps the copy button hidden until the parent is hovered. The `hidden` default lives here
 * (not on the button) so it stays class-based and the `:hover` rule can override it.
 */
export const revealCopyIconOnHoverSx = {
    [`.${COPY_ICON_CLASS}`]: { visibility: 'hidden' },
    [`&:hover .${COPY_ICON_CLASS}`]: { visibility: 'visible' },
} as const;
